<template>
  <div class="is-grid is-row-4">
    <f-field 
      class="is-col-12"
      label="Adresse"
    >
      <f-select 
        v-model="address"
        :options="results"
        @search="fetch"
        placeholder="Recherche une adresse"
        searchable  
        long
      >
        <template #option="{ option }">
          <div>
            {{ option.place_name_fr }}
          </div>  
        </template>
      </f-select>
    </f-field>

    <f-field 
      class="is-col-4"
      label="Numéro"
    >
      <f-input 
        v-model="customAddress.numero"
      ></f-input>
    </f-field>

    <f-field 
      class="is-col-8"
      label="Rue"
    >
      <f-input 
        v-model="customAddress.street"
      ></f-input>
    </f-field>

    <f-field 
      class="is-col-4"
      label="Code postal"
    >
      <f-input 
        v-model="customAddress.zipcode"
      ></f-input>
    </f-field>

    <f-field 
      class="is-col-8"
      label="Ville"
    >
      <f-input 
        v-model="customAddress.city"
      ></f-input>
    </f-field>

    <f-field 
      class="is-col-6"
      label="Pays"
    >
      <f-input 
        v-model="customAddress.country"
      ></f-input>
    </f-field>
  </div>
</template>

<script>
  import { reactive, toRefs, watch } from 'vue'
  import useGeo from '@composables/use-geo'

  export default {
    props: {
      modelValue: {
        type: Object,
        default: () => ({}),
      },
    },

    setup (props, context) {
      const { results, getAddresses, getAddressFromCenter } = useGeo()

      const state = reactive({
        results: results,
        address: {},
        customAddress: {
          country: props.modelValue.country || '',
          country_code: props.modelValue.country_code || '',
          region: props.modelValue.region || '',
          department: props.modelValue.department || '',
          zipcode: props.modelValue.zipcode || '',
          city: props.modelValue.city || '',
          numero: props.modelValue.numero || '',
          street: props.modelValue.street || '',
        },
        loading: false,
      })

      async function fetch (search) {
        try {
          getAddresses({ 
            search: search,
          })
        } catch (error) {
          
        }
      }

      async function getLocation () {
        state.loading = true 

        let address = {
          country: '',
          country_code: '',
          region: '',
          department: '',
          zipcode: '',
          city: '',
          numero: '',
          street: ''
        }

        try {
          const center = {
            lat: state.address.center[1],
            long: state.address.center[0],
          }
          const location = await getAddressFromCenter(center)

          address.country = location.country || ''
          address.country_code = location.country_code || ''
          address.region = location.state || ''
          address.zipcode = location.postcode || ''
          address.city = location.city || location.village || ''
          address.street = location.road || ''
          address.numero = location.house_number 
            || (/^[0-9]{1,}$/.test(state.address.address) ? state.address.address : '')
          address.department = location.country_code === 'fr'
            ? location.postcode.match(/^([0-9]{1}[0-5]{1}|97[0-9]{1})/)?.[0]
            : ''
        } catch (error) {
          console.log('error', error)
        }

        state.loading = false

        state.customAddress = address
      }

      watch(() => state.address, () => getLocation())
      watch(() => state.customAddress, newValue => {
        console.log(state.customAddress)
        context.emit('update:modelValue', state.customAddress)
      })

      return {
        ...toRefs(state),
        fetch,
      }
    } 
  }
</script>